import { Box, styled } from "@mui/material";

export const MessageInput = styled(Box)(({ theme }) => ({
  padding: "16px",
  borderTop: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  gap: "8px",
  background: theme.palette.background.paper,
}));
